import React from "react";
import {
  faClipboardQuestion,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function Contact_details_card() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Contact_details_card">
        <div className="content_box_holder">
          <div className="heading_strip_holder">
            <h1>CONTACT US</h1>
            <hr />
          </div>
          <div className="content_holder">
            <div className="text_holder">
              <h6>
                <FontAwesomeIcon icon={faClipboardQuestion} className="me-2" />{" "}
                FAQs
              </h6>
              <p>
                The answer to your question can certainly be found in the
                <b
                  className="text_decoration_holder"
                  onClick={() => navigate("/luxury/faq")}
                >
                  {" "}
                  FAQs
                </b>
              </p>
            </div>
            <hr />
            <div className="text_holder">
              <h6>
                <FontAwesomeIcon icon={faPhone} className="me-2" /> Customer
                Service
              </h6>
              <p>You can also contact us outside public holidays:</p>
              <p>Monday to Saturday 10:00 am - 06:00 pm IST</p>
              <p>
                <span>+91 731 6711 800/ +91 93029 11233</span>
              </p>
              <p>
                Email Us: <span>sales@mittalcraftworks.com</span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact_details_card;
